import React from 'react';
import { SvgIcon } from '@mui/material';

function ErrorsIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 116 106">
      <path
        d="M101.72 105.04H14.29C9.35995 105.04 4.95995 102.48 2.51995 98.1999C0.0799497 93.9199 0.109948 88.8199 2.61995 84.5799L48.08 7.59993C50.6 3.34993 55.0799 0.859933 59.9899 0.959933C64.9299 1.04993 69.2899 3.69993 71.6499 8.04993L113.61 84.9599C115.93 89.2199 115.83 94.2399 113.35 98.4099C110.88 102.56 106.53 105.04 101.7 105.04H101.72ZM54.54 11.4199L9.07995 88.3899C7.95995 90.2899 7.93995 92.5699 9.03995 94.4799C10.13 96.3899 12.1 97.5299 14.3 97.5299H101.73C103.91 97.5299 105.81 96.4499 106.93 94.5699C108.04 92.6999 108.08 90.4499 107.05 88.5399L65.0799 11.6299C64.0199 9.67993 62.07 8.49993 59.87 8.45993C57.72 8.47993 55.68 9.51993 54.55 11.4199H54.54Z"
        fill="currentColor"
      />
      <path
        d="M63.3199 29.95L62.7799 69.37H56.5699L56.0299 29.95H63.3099H63.3199ZM59.6799 85.25C58.3599 85.25 57.2199 84.77 56.2799 83.8C55.3299 82.89 54.8599 81.71 54.8599 80.42C54.8599 79.13 55.3299 77.95 56.2799 76.99C57.2199 76.08 58.3599 75.6 59.6799 75.6C60.9999 75.6 62.1399 76.08 63.0799 76.99C64.0299 77.96 64.4999 79.08 64.4999 80.42C64.4999 81.28 64.2699 82.08 63.8299 82.83C63.3999 83.53 62.8199 84.12 62.0899 84.6C61.3799 85.03 60.5699 85.24 59.6799 85.24V85.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default ErrorsIcon;
